import React from 'react';
import { Tab, TabController, Tabs } from '@one-thd/sui-atomic-components';
import QuotesTabPanels from './QuotesTabPanels';
import { useQuoteContext } from '../../hooks/useQuoteContext';
import { triggerAnalyticsCustomEvent } from '../../utils/analyticsEvents';

const QuotesTabsView = () => {
  const {
    selectedTab,
    setSelectedTab,
    activeQuotes,
    expiredQuotes,
    isMobile
  } = useQuoteContext();

  const selectedTabOnChange = (_event, newValue) => {
    triggerAnalyticsCustomEvent('quotes.interaction-click', {
      component: `${newValue} quotes tab`,
    });
    setSelectedTab(newValue);
  };

  return (
    <TabController value={selectedTab}>
      <Tabs
        value={selectedTab}
        onChange={selectedTabOnChange}
        aria-label="Quotes status tabs"
        variant={isMobile ? 'fullWidth' : 'standard'}
      >
        <Tab label={`Active (${activeQuotes?.length})`} value="active" />
        <Tab label={`Expired (${expiredQuotes?.length})`} value="expired" />
      </Tabs>
      <QuotesTabPanels />
    </TabController>
  );
};

QuotesTabsView.propTypes = {};
QuotesTabsView.defaultProps = {};

export default QuotesTabsView;
